import { TranslationKey } from "../../functions/translate";
import { StringSchema } from "../../classes/schema";
import { mbiRegex } from "../../functions/isValidMedicareNumber";
const atLeastOneNumber = /\d/;
const atLeastOneLetter = /[a-z]/i;
const atLeastOneAllowedSpecialChar = /[@!$%^*()]/;
const validCharsOnly = /^[0-9a-z@!$%^*()]*$/i;

export type PasswordErrState = 'invalidLength' | 'missingOrInvalidCharType' | 'containsMBI';
const errorMessages: {
    [err in PasswordErrState] : TranslationKey
} = {
    invalidLength: 'enter_password_eight_to_sixteen_char',
    missingOrInvalidCharType: 'enter_password_letter_number_symbol',
    containsMBI: "enter_password_no_mbi"
}

const passwordSchema = new StringSchema()
    .matches(validCharsOnly, errorMessages.missingOrInvalidCharType)
    .betweenLength(8, 16, errorMessages.invalidLength)
    .matches(atLeastOneLetter, errorMessages.missingOrInvalidCharType)
    .matches(atLeastOneNumber, errorMessages.missingOrInvalidCharType)
    .matches(atLeastOneAllowedSpecialChar, errorMessages.missingOrInvalidCharType)
    .test('no MBI', errorMessages.containsMBI, password => {
        return !password?.match(mbiRegex);
    });

export const getPasswordErrors = (password: string): Set<PasswordErrState> => {
    const passwordErrs = passwordSchema.validate(password);
    const errSet = new Set<PasswordErrState>();

    for (const key in errorMessages) {
        const errType = key as PasswordErrState;
        const message = errorMessages[errType];
        if (passwordErrs?.includes(message)) {
            errSet.add(errType);
        }
    }

    return errSet;
}

export const getPasswordErrorMessage = (err: PasswordErrState): TranslationKey => errorMessages[err];
